import React from "react";
import { Switch } from "../ui/switch";
import { Input } from "../ui/input";
import { Button } from "../ui/button";
import { Field, Pick } from "../loans/LoanFormDialog";
import { TYPES, TYPE_LABEL, TYPE_HINT } from "./constants";
import { Loader2 } from "lucide-react";

export const SettingsPanel = ({ s, setS, onSave, saving }) => {
  const setType = (t, k, v) => setS((p) => ({ ...p, types: { ...p.types, [t]: { ...p.types[t], [k]: v } } }));
  return (
    <div className="space-y-5" data-testid="reminder-settings-panel">
      <div className="divide-y divide-emerald-950/5 rounded-2xl border border-emerald-950/10 bg-white">
        {TYPES.map((t) => (
          <div key={t} className="grid gap-3 p-4 md:grid-cols-[1fr_280px] md:items-center">
            <label className="flex items-start gap-3">
              <Switch checked={s.types[t].enabled} onCheckedChange={(v) => setType(t, "enabled", v)} data-testid={`reminder-toggle-${t}`} className="mt-0.5" />
              <span><span className="block text-sm font-semibold text-emerald-950">{TYPE_LABEL[t]}</span>
                <span className="text-xs text-emerald-900/60">{TYPE_HINT[t]}</span></span>
            </label>
            <Input value={s.types[t].meta_template} onChange={(e) => setType(t, "meta_template", e.target.value.toLowerCase())}
              placeholder="Approved Meta template name" className="h-9 font-mono text-xs" data-testid={`reminder-meta-template-${t}`} />
          </div>
        ))}
      </div>
      <div className="grid gap-4 rounded-2xl border border-emerald-950/10 bg-white p-4 sm:grid-cols-2 lg:grid-cols-4">
        <Field label="Preferred sending time">
          <Input type="time" value={s.send_time} onChange={(e) => setS({ ...s, send_time: e.target.value })} data-testid="reminder-send-time" />
        </Field>
        <Field label="Message language">
          <Pick testId="reminder-language" value={s.language} onChange={(v) => setS({ ...s, language: v })}
            options={[{ value: "bn", label: "বাংলা (Bengali)" }, { value: "en", label: "English" }]} />
        </Field>
        <Field label="Max send attempts">
          <Pick testId="reminder-max-attempts" value={String(s.max_attempts)} onChange={(v) => setS({ ...s, max_attempts: Number(v) })}
            options={[1, 2, 3, 4, 5].map((n) => ({ value: String(n), label: `${n} attempt${n > 1 ? "s" : ""}` }))} />
        </Field>
        <Field label="Meta language codes (bn / en)">
          <div className="flex gap-2">
            {["bn", "en"].map((l) => <Input key={l} value={s.meta_lang_codes[l]} className="h-10 font-mono text-xs" data-testid={`reminder-lang-code-${l}`}
              onChange={(e) => setS({ ...s, meta_lang_codes: { ...s.meta_lang_codes, [l]: e.target.value } })} />)}
          </div>
        </Field>
      </div>
      <p className="text-xs text-emerald-900/60">Template names and language codes must match the templates Meta has approved for your WhatsApp Business account.</p>
      <Button onClick={onSave} disabled={saving} className="bg-[#0F4C3A] text-white hover:bg-emerald-900" data-testid="reminder-settings-save">
        {saving && <Loader2 className="mr-2 h-4 w-4 animate-spin" />}Save settings
      </Button>
    </div>
  );
};
